var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12.5H12l6.196 8.26-5.859 6.74h1.988l4.791-5.512L23.25 27.5h5.25l-6.456-8.608L27.6 12.5h-1.987l-4.49 5.164L17.25 12.5zM24 26l-9-12h1.5l9 12H24z",
    fill: "#7F7B71"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+CiAgPHBhdGgKICAgIGQ9Ik01LjI1IDAuNUgwTDYuMTk1NjUgOC43NjA4N0wwLjMzNzQ2MiAxNS40OTk5SDIuMzI0OThMNy4xMTYyMyA5Ljk4ODI1TDExLjI1IDE1LjVIMTYuNUwxMC4wNDM4IDYuODkxNzJMMTUuNjAwMSAwLjVIMTMuNjEyNkw5LjEyMzIyIDUuNjY0MzRMNS4yNSAwLjVaTTEyIDE0TDMgMkg0LjVMMTMuNSAxNEgxMloiCiAgICBmaWxsPSIjN0Y3QjcxIgogICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIsIDEyKSIKICAvPgo8L3N2Zz4K";
export { SvgTwitter as ReactComponent };